import cx from 'classnames';
import * as React from 'react';

import Heading from 'components/Heading';
import { MouseEventHandler } from 'types/typescript/eventHandlers';
import Row from 'components/Row';
import Text from 'components/Text';
import TextWithIcon from 'components/TextWithIcon';

import { IconColor, IconName } from 'components/Icon';

import './ActionsList.scss';

type SectionItems = {
  active?: boolean;
  action: MouseEventHandler;
  copy: string;
  // this allows us to dynamically choose whether or not to show a particular section
  // ex: for direct add we only show sms instructions if sms is enabled for the current user
  hide?: boolean;
  icon?: IconName;
  iconColor?: IconColor;
};

type Section = {
  items: Array<SectionItems>;
  title?: string;
};

type Props = {
  data: Array<Section>;
};

export default function ActionsList({ data }: Props) {
  return (
    <nav className="ActionsList" data-test-selector="actions-list">
      {data.map((section, index) => (
        <Row size={index + 1 === data.length ? 'small' : 'large'} key={section.items[0].copy}>
          <section>
            {section.title && (
              <Heading level="3" className="ActionsList-section-title">
                {section.title}
              </Heading>
            )}

            {section.items.map(item => {
              if (item.hide) {
                return null;
              }

              const body = item.icon ? (
                <TextWithIcon icon={item.icon} iconColor={item.iconColor}>
                  {item.copy}
                </TextWithIcon>
              ) : (
                item.copy
              );

              return (
                <button
                  key={item.copy}
                  onClick={item.action}
                  className={cx('ActionsList-button', item.active && 'ActionsList-button--active')}>
                  <Text color={item.active ? 'pitch' : 'thunder'} weight="semibold">
                    {body}
                  </Text>
                </button>
              );
            })}
          </section>
        </Row>
      ))}
    </nav>
  );
}
